import styled from "@emotion/styled";
import { mediaQueriesMax, mediaQueryLessonSSmobileHeight } from "@src/styles/theme";
import { css } from "@emotion/react";
import { Link } from "gatsby";

const GeoFenceContainer = styled.div`
  min-width: 100%;
  min-height: 450px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: black;
  border-radius: 12px;
`;

const LessonSS = styled.div`
  position: relative;

  height: auto;
  min-height: 100vh;
  padding: 64px 172px 0 172px;

  background-color: #2c2f42;

  ${mediaQueriesMax.lessonSSmobile} {
    padding: 26px 0;
  }

  @media screen and (orientation: portrait) {
    ${mediaQueryLessonSSmobileHeight} {
      padding: 16px 0;
    }
  }

  @media screen and (orientation: landscape) {
    ${mediaQueryLessonSSmobileHeight} {
      height: auto;
    }
  }

  &:after {
    content: " ";
    display: table;
    clear: both;
  }

  overflow: scroll;
`;

const LessonSSContainer = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  max-width: 950px;
  margin: 0 auto;

  ${mediaQueriesMax.lessonSSmobile} {
    padding: 0 10px;
  }

  &:after {
    content: " ";
    display: table;
    clear: both;
  }
`;

const LessonSSClose = styled(Link)`
  position: fixed;
  top: 68px;
  right: 48px;
  z-index: 10;

  opacity: 0.5;

  ${mediaQueriesMax.lessonSSmobile} {
    position: absolute;
    top: 5px;
    right: 24px;
  }

  @media screen and (orientation: portrait) {
    ${mediaQueryLessonSSmobileHeight} {
      top: 5px;
    }
  }

  &:hover {
    opacity: 1;
  }
`;

const LessonSSHeader = styled.div`
  max-width: 950px;
  width: 100%;
  height: 166px;
  padding: 0 14px;

  ${mediaQueriesMax.lessonSSmobile} {
    height: 97px;
    padding: 0;
  }

  @media screen and (orientation: portrait) {
    ${mediaQueryLessonSSmobileHeight} {
      height: 97px;
    }
  }

  &:after {
    content: " ";
    display: table;
    clear: both;
  }
`;

const LessonSSHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &:after {
    content: " ";
    display: table;
    clear: both;
  }
`;

const LessonSSTitle = styled.div`
  width: 100%;

  font-family: "HafferXH", serif;
  font-size: 2em;
  font-weight: bold;
  text-align: center;
  color: #ffffff;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${mediaQueriesMax.lessonSSmobile} {
    width: calc(100% - 80px);
    font-size: 20px;
  }
`;

const LessonSSBody = styled.div`
  max-width: 950px;
  width: 100%;
  margin: 19px 0 0 0;

  ${mediaQueriesMax.lessonSSmobile} {
    margin: 15px 0 0 0;
  }

  &:after {
    content: " ";
    display: table;
    clear: both;
  }
`;

const lessonSSSlide = css`
  max-height: 52vh;
  min-height: 340px;

  border-radius: 16px;
  overflow: hidden;
  background-color: white;

  &:after {
    content: " ";
    display: table;
    clear: both;
  }
`;

const video = css`
  position: relative;
  display: inline-block;
  color: #fff;
  font-family: Helvetica, serif;
  background-color: #000;
  -webkit-font-smoothing: antialiased;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  &:focus {
    outline: thin dotted;
  }
`;

const IsVideo = styled.div`
  ${lessonSSSlide};
  background-color: black;

  max-height: unset;
  min-height: unset;
`;

const isVideo16per9 = css`
  max-width: 950px;
  max-height: 534px;
  min-height: unset;
  width: 100%;
`;

const IsHtml = styled.div`
  ${lessonSSSlide};
  max-height: 66vw;
  height: 66vh;

  ${mediaQueriesMax.lessonSSmobile} {
    height: 52vh;
  }

  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;

  text-align: center;
`;

const lessonSSSlideContent = css`
  color: #363636;

  img {
    width: 100%;
    height: auto;
  }

  .is-text {
    margin: 20px;
  }

  .is-footer {
    border-top: 1px solid darken(#f5f5f3, 5%);
    padding: 16px 0;
    text-align: center;
  }

  .is-title {
    font-weight: 600;
    font-size: 18px;
    margin-bottom: 10px;
  }

  p {
    margin: 0 0 20px;
  }
`;
const LessonSSHtmlSlideContent = styled.div`
  ${lessonSSSlideContent};

  box-shadow: unset;
  border: none;
  border-radius: 5px;

  * > &:last-of-type {
    margin-bottom: 0;
  }

  &.is-naked {
    padding: 0;
  }
  width: 100%;
  height: 100%;
  padding: 10px 20px;
  margin: 0 auto;

  overflow-y: auto;
  text-align: left;

  h1 {
    font-size: 32px;
    line-height: 48px;
    color: #363636;
    margin: 0.75em 0;
    font-weight: 700;

    ${mediaQueriesMax.lessonSSmobile} {
      font-size: 20px;
    }

    ${mediaQueryLessonSSmobileHeight} {
      font-size: 20px;
    }
  }

  h2 {
    font-size: 24px;
    line-height: 36px;
    color: #363636;
    font-weight: 700;
  }

  h3 {
    font-size: 22px;
    line-height: 32px;
    color: #363636;
    font-weight: 700;
  }

  ${mediaQueriesMax.lessonSSmobile} {
    width: 100%;
    padding: 10px 20px;
  }

  &:after {
    content: " ";
    display: table;
    clear: both;
  }
`;

const discussion = css`
  width: 48%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  > * {
    max-width: 100%;
  }

  ${mediaQueriesMax.lessonSSmobile} {
    width: 90%;
  }

  @media screen and (orientation: landscape) {
    ${mediaQueryLessonSSmobileHeight} {
      width: 90%;
    }
  }
`;

const IsShare = styled.div`
  ${lessonSSSlide};
  overflow: visible;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  max-height: unset;
  padding: 40px;

  ${mediaQueriesMax.lessonSSmobile} {
    padding: 20px 22px 25px;
  }
`;

const LessonSSShareSlideContent = styled.div`
  background: #fff;
  box-shadow: 0 1px 1px rgba(#000, 0.05);
  border-radius: 5px;

  * > &:last-of-type {
    margin-bottom: 0;
  }

  &.is-naked {
    padding: 0;
  }
  border: none;

  width: 100%;
  height: 100%;
  margin: 0 auto;

  overflow-y: visible;
  text-align: left;

  ${mediaQueriesMax.lessonSSmobile} {
    padding: 10px 20px;
    width: 100%;
    max-width: 500px;
  }

  max-width: 500px;

  &:after {
    content: " ";
    display: table;
    clear: both;
  }
`;

const LessonSSNav = styled.div`
  &:after {
    content: " ";
    display: table;
    clear: both;
  }

  ${mediaQueriesMax.lessonSSmobile} {
    position: relative;
    bottom: 0;

    width: 100%;
    height: 100px;
    margin: 20px auto;
  }

  @media screen and (orientation: portrait) {
    ${mediaQueryLessonSSmobileHeight} {
      height: 70px;
      bottom: 0;
    }
  }

  @media screen and (orientation: landscape) {
    ${mediaQueryLessonSSmobileHeight} {
      position: relative;
      bottom: unset;

      height: 100px;
    }
  }

  > * {
    display: flex;
    align-items: center;
    justify-content: center;

    position: absolute;
    top: calc(50% + 51px);
    z-index: 100;

    width: 100px;
    height: 100px;
    border-radius: 60px;
    border: solid 2px #ffffff;

    ${mediaQueriesMax.lessonSSmobile} {
      top: unset;
      bottom: 0;
    }

    @media screen and (orientation: portrait) {
      ${mediaQueryLessonSSmobileHeight} {
        top: unset;
        bottom: 0;
        width: 70px;
        height: 70px;
      }
    }

    @media screen and (orientation: landscape) {
      ${mediaQueryLessonSSmobileHeight} {
        top: unset;
        bottom: 0;
      }
    }

    &:hover {
      cursor: pointer;
    }
  }
`;

const LessonSSSlideTitle = styled.div`
  text-align: center;
  font-size: 18px;
  color: #575b7d;
  margin-bottom: 12px;
`;

const materialIcon = css`
  object-fit: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 44px 44px;
  width: 44px;
  height: 44px;
`;

const LessonSSSlideCompose = styled.div`
  img {
    height: auto;
    width: auto;
    max-width: initial;
  }
`;

const MaterialIconCheck = styled.div`
  background-image: url(data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjRkZGRkZGIiBoZWlnaHQ9IjQ4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSI0OCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4gICAgPHBhdGggZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIvPiAgICA8cGF0aCBkPSJNOSAxNi4xN0w0LjgzIDEybC0xLjQyIDEuNDFMOSAxOSAyMSA3bC0xLjQxLTEuNDF6Ii8+PC9zdmc+);
  ${materialIcon}
`;

const MaterialIconClose = styled.div`
  background-image: url(data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjRkZGRkZGIiBoZWlnaHQ9IjQ4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSI0OCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4gICAgPHBhdGggZD0iTTE5IDYuNDFMMTcuNTkgNSAxMiAxMC41OSA2LjQxIDUgNSA2LjQxIDEwLjU5IDEyIDUgMTcuNTkgNi40MSAxOSAxMiAxMy40MSAxNy41OSAxOSAxOSAxNy41OSAxMy40MSAxMnoiLz4gICAgPHBhdGggZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIvPjwvc3ZnPg==);
  ${mediaQueriesMax.lessonSSmobile} {
    background-size: 22px 22px;
    width: 22px;
    height: 22px;
  }
  ${materialIcon}
`;

const MaterialIconArrowForward = styled.div`
  background-image: url(data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjRkZGRkZGIiBoZWlnaHQ9IjQ4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSI0OCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4gICAgPHBhdGggZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIvPiAgICA8cGF0aCBkPSJNMTIgNGwtMS40MSAxLjQxTDE2LjE3IDExSDR2MmgxMi4xN2wtNS41OCA1LjU5TDEyIDIwbDgtOHoiLz48L3N2Zz4=);
  ${materialIcon}
`;

const MaterialIconArrowBack = styled.div`
  background-image: url(data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjRkZGRkZGIiBoZWlnaHQ9IjQ4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSI0OCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4gICAgPHBhdGggZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIvPiAgICA8cGF0aCBkPSJNMjAgMTFINy44M2w1LjU5LTUuNTlMMTIgNGwtOCA4IDggOCAxLjQxLTEuNDFMNy44MyAxM0gyMHYtMnoiLz48L3N2Zz4=);
  ${materialIcon}
`;

const illustrationIcon = css`
  position: absolute;
  background-repeat: no-repeat;
  background-position: center;
  object-fit: contain;

  ${mediaQueriesMax.lessonSSmobile} {
    display: none;
  }

  @media screen and (orientation: portrait) {
    ${mediaQueryLessonSSmobileHeight} {
      display: none;
    }
  }

  @media screen and (orientation: landscape) {
    ${mediaQueryLessonSSmobileHeight} {
      display: none;
    }
  }
`;

const BruceDiscuss = styled.div`
  ${illustrationIcon};
  bottom: 4vmin;
  right: 1vmin;

  width: 15vmin;
  height: 17vmin;
  background-size: 15vmin 17vmin;
  background-image: url(data:image/svg+xml;base64,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);
`;

const BruceDiscussBalloon = styled.div`
  ${illustrationIcon};
  bottom: 20vmin;
  right: 13vmin;

  width: 8vmin;
  height: 8vmin;
  background-size: 8vmin 8vmin;
  background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzUiIGhlaWdodD0iNzUiIHZpZXdCb3g9IjAgMCA3NSA3NSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PHRpdGxlPjRCMUNBMDRELTdGMDQtNEZGOC1BMDI5LTJCNjJGMTMyNjJCODwvdGl0bGU+PGRlZnM+PHBhdGggZD0iTTM0LjUgNjljOC4yNTQgMCAxNS44My0yLjg5OCAyMS43NjgtNy43MzMuOTIxLS43NSA0LjM1OC44NCA1LjE5NyAwIC45MDQtLjkwNC0uNzk5LTQuMjQ1IDAtNS4yNDVBMzQuMzU0IDM0LjM1NCAwIDAgMCA2OSAzNC41QzY5IDE1LjQ0NiA1My41NTQgMCAzNC41IDAgMTUuNDQ2IDAgMCAxNS40NDYgMCAzNC41IDAgNTMuNTU0IDE1LjQ0NiA2OSAzNC41IDY5eiIgaWQ9ImEiLz48L2RlZnM+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzIDMpIj48dXNlIGZpbGw9IiNGRkYiIHhsaW5rOmhyZWY9IiNhIi8+PHBhdGggc3Ryb2tlLW9wYWNpdHk9Ii4xMiIgc3Ryb2tlPSIjMDAwIiBzdHJva2Utd2lkdGg9IjMiIGQ9Ik01Ny4wNTUgNjIuNTZjLjA0NyAwIC4xMDcgMCAuMTguMDA1LjI5My4wMTcuNTk5LjA2NSAxLjMzLjJsLjAwOC4wMDJjMi4zNTUuNDM0IDMuMDQ5LjQ2NyAzLjk1NC0uNDQuOTM1LS45MzYuODk3LTEuNjc4LjQzNi00LjAwM3YtLjAwMWMtLjE0My0uNzItLjE5NC0xLjAyMy0uMjEzLTEuMzEyYTEuOTk1IDEuOTk1IDAgMCAxLS4wMDQtLjE4OUEzNS44NDggMzUuODQ4IDAgMCAwIDcwLjUgMzQuNWMwLTE5Ljg4Mi0xNi4xMTgtMzYtMzYtMzZzLTM2IDE2LjExOC0zNiAzNiAxNi4xMTggMzYgMzYgMzZhMzUuODUgMzUuODUgMCAwIDAgMjIuNTU1LTcuOTR6Ii8+PC9nPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE5Ljg0MyAyNy40NDkpIiBmaWxsPSIjMDAwIiBvcGFjaXR5PSIuMDUiPjxyZWN0IHg9IjMuNjc5IiB3aWR0aD0iMjcuOTU4IiBoZWlnaHQ9IjIuMTczIiByeD0iMS4wODciLz48cmVjdCB5PSI1LjQzMyIgd2lkdGg9IjM1LjMxNSIgaGVpZ2h0PSIyLjE3MyIgcng9IjEuMDg3Ii8+PHJlY3QgeD0iMy42NzkiIHk9IjEwLjg2NiIgd2lkdGg9IjI3Ljk1OCIgaGVpZ2h0PSIyLjE3MyIgcng9IjEuMDg3Ii8+PHJlY3QgeD0iMS44MzkiIHk9IjE2LjI5OSIgd2lkdGg9IjMxLjYzNiIgaGVpZ2h0PSIyLjE3MyIgcng9IjEuMDg3Ii8+PHJlY3QgeD0iNy4zNTciIHk9IjIxLjczMiIgd2lkdGg9IjIwLjYiIGhlaWdodD0iMi4xNzMiIHJ4PSIxLjA4NyIvPjwvZz48L2c+PC9zdmc+);
`;

const KatieDiscuss = styled.div`
  ${illustrationIcon};
  bottom: 4vmin;
  left: 4vmin;

  width: 12vmin;
  height: 15vmin;
  background-size: 12vmin 15vmin;
  background-image: url(data:image/svg+xml;base64,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);
`;

const KatieDiscussBalloon = styled.div`
  ${illustrationIcon};
  bottom: 17vmin;
  left: 12vmin;

  width: 10vmin;
  height: 10vmin;
  background-size: 10vmin 10vmin;
  background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTciIGhlaWdodD0iOTciIHZpZXdCb3g9IjAgMCA5NyA5NyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PHRpdGxlPjEyRUJGRTQyLTVEQUEtNDg0Ni1BMTQyLTExNDk4Mjc1REIzODwvdGl0bGU+PGRlZnM+PHBhdGggZD0iTTQ1LjUgOTFhNDUuMzExIDQ1LjMxMSAwIDAgMCAyOC43MDgtMTAuMTk4YzEuMjE1LS45OSA1Ljc0OSAxLjEwOCA2Ljg1NSAwIDEuMTkxLTEuMTkzLTEuMDU0LTUuNiAwLTYuOTE3QTQ1LjMwOCA0NS4zMDggMCAwIDAgOTEgNDUuNUM5MSAyMC4zNzEgNzAuNjI5IDAgNDUuNSAwUzAgMjAuMzcxIDAgNDUuNSAyMC4zNzEgOTEgNDUuNSA5MXoiIGlkPSJhIi8+PC9kZWZzPjxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PGcgdHJhbnNmb3JtPSJtYXRyaXgoLTEgMCAwIDEgOTQgMykiPjx1c2UgZmlsbD0iI0ZGRiIgeGxpbms6aHJlZj0iI2EiLz48cGF0aCBzdHJva2Utb3BhY2l0eT0iLjEyIiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMyIgZD0iTTc1LjA2IDgyLjA0MmMuMS0uMDE1LjI1My0uMDE4LjQ1Mi0uMDA2LjQxMy4wMjQuODI4LjA5IDEuODEyLjI3bC4wMTEuMDAzYzIuODc4LjUzIDMuNzcuNTczIDQuNzktLjQ0NyAxLjA1Ny0xLjA1OSAxLjAxLTIgLjQ0NC00Ljg0OHYtLjAwMmMtLjE5My0uOTcxLS4yNjItMS4zODItLjI4OS0xLjc5MmEyLjEyMyAyLjEyMyAwIDAgMSAuMDEtLjQ2NWMuMDAzLS4wMi0uMDA4LjAwNy0uMDU1LjA2NkM4OC44NCA2Ni41NTUgOTIuNSA1Ni4zMDUgOTIuNSA0NS41YzAtMjUuOTU3LTIxLjA0My00Ny00Ny00N3MtNDcgMjEuMDQzLTQ3IDQ3IDIxLjA0MyA0NyA0NyA0N2MxMC45MTMgMCAyMS4yNTctMy43MzMgMjkuNTYtMTAuNDU4eiIvPjwvZz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMC4yNzggMzYuNDA1KSIgZmlsbD0iIzAwMCIgb3BhY2l0eT0iLjA1Ij48cmVjdCB4PSI1Ljc1OSIgd2lkdGg9IjQzLjc3MiIgaGVpZ2h0PSIyLjMwNCIgcng9IjEuMTUyIi8+PHJlY3QgeT0iNS43NTkiIHdpZHRoPSI1NS4yOTEiIGhlaWdodD0iMi4zMDQiIHJ4PSIxLjE1MiIvPjxyZWN0IHg9IjUuNzU5IiB5PSIxMS41MTkiIHdpZHRoPSI0My43NzIiIGhlaWdodD0iMi4zMDQiIHJ4PSIxLjE1MiIvPjxyZWN0IHg9IjIuODgiIHk9IjE3LjI3OCIgd2lkdGg9IjQ5LjUzMiIgaGVpZ2h0PSIyLjMwNCIgcng9IjEuMTUyIi8+PHJlY3QgeD0iMTEuNTE5IiB5PSIyMy4wMzgiIHdpZHRoPSIzMi4yNTMiIGhlaWdodD0iMi4zMDQiIHJ4PSIxLjE1MiIvPjwvZz48L2c+PC9zdmc+);
`;

const isPrev = css`
  left: -150px;
  background-color: transparent;

  &:hover {
    color: white;
    border-color: white;
  }

  ${mediaQueriesMax.lessonSSmobile} {
    left: 50px;
  }
`;

const isFirst = css`
  opacity: 0.5;

  &:hover {
    opacity: 1;
  }
`;

const isNext = css`
  right: -150px;

  background: #00aeef;
  border-color: #00aeef;

  &:hover {
    background: #00baff;
    border-color: #00baff;
  }

  ${mediaQueriesMax.lessonSSmobile} {
    right: 50px;
  }
`;

const LessonSSCrumbs = styled.div`
  width: 100%;
  margin: 54px 0 0 0;

  ${mediaQueriesMax.lessonSSmobile} {
    margin: 19px 0 0 0;
  }

  @media screen and (orientation: portrait) {
    ${mediaQueryLessonSSmobileHeight} {
      margin: 19px 0 0 0;
    }
  }

  > ul {
    width: 100%;
    padding: 0;
    margin: 0;

    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;

    list-style: none;

    .lesson-ss__crumbs__item {
      flex-grow: 1;

      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      height: 64px;
      margin: 0 5.2px;

      border-radius: 4px;
      background-color: #ffffff;
      border: 1px solid white;

      opacity: 0.5;

      ${mediaQueriesMax.lessonSSmobile} {
        height: 48px;
        margin: 0 2.05px;
      }

      &:first-of-type {
        margin-left: 0;
      }

      &:last-of-type {
        margin-right: 0;
      }

      &:hover {
        cursor: pointer;
        color: white;
        border-color: white;
      }

      &.is-active {
        opacity: 1;

        .lesson-ss__crumbs__item__title {
          ${mediaQueriesMax.lessonSSmobile} {
            height: 17px;
          }
        }

        ~ .lesson-ss__crumbs__item {
          background-color: transparent;

          &:hover {
            opacity: 1;
          }

          .lesson-ss__crumbs__item__title {
            font-weight: 500;
            color: #ffffff;
          }
        }

        &.has-multiple-slides {
          display: block;
        }
      }

      &.has-multiple-slides {
        display: none;

        > button {
          height: 100%;
        }
      }

      > button {
        width: 100%;
        height: 100%;
        background-color: transparent;
        border: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .lesson-ss__crumbs__item__title {
          font-family: "HafferXH", serif;
          font-size: 20px;
          font-weight: 600;
          text-align: center;
          color: #3e425d;
          line-height: 1;

          ${mediaQueriesMax.lessonSSmobile} {
            font-size: 16px;
          }
        }

        ul.lesson-ss__crumbs__item__list {
          list-style: none;

          height: 6px;
          margin: 10px 0 0 0;
          padding: 0;

          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;

          > * {
            width: 6px;
            height: 6px;
            margin: 0 4px;
            border-radius: 10px;

            background-color: #d8d9de;

            ${mediaQueriesMax.lessonSSmobile} {
              width: 4px;
              height: 4px;
              margin: 0 3px;
            }

            &.is-active {
              background-color: #00aeef;
            }
          }
        }
      }
    }
  }
`;
export {
  LessonSS,
  LessonSSBody,
  LessonSSClose,
  LessonSSContainer,
  illustrationIcon,
  materialIcon,
  BruceDiscuss,
  BruceDiscussBalloon,
  discussion,
  IsHtml,
  IsShare,
  IsVideo,
  video,
  isVideo16per9,
  KatieDiscuss,
  KatieDiscussBalloon,
  LessonSSHeader,
  LessonSSHeaderContainer,
  LessonSSHtmlSlideContent,
  LessonSSSlideCompose,
  LessonSSNav,
  LessonSSShareSlideContent,
  lessonSSSlideContent,
  LessonSSSlideTitle,
  LessonSSTitle,
  MaterialIconArrowBack,
  MaterialIconArrowForward,
  MaterialIconCheck,
  MaterialIconClose,
  isPrev,
  isFirst,
  isNext,
  LessonSSCrumbs,
  GeoFenceContainer,
};
